import { Injectable } from '@angular/core';
import { Router, RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
import { Observable, of, EMPTY } from 'rxjs';
import { catchError, mergeMap } from 'rxjs/operators';

import { CourseService } from '@courses/services/course.service';
import { Course, SharedService } from '@app/core';

@Injectable({
  providedIn: 'root',
})
export class CourseDetailResolverService {
  constructor(
    private courseService: CourseService,
    private sharedService: SharedService,
    private router: Router
  ) {}

  private handleError = () => {
    this.sharedService.errorAlert('Something wrong!');
    this.router.navigate(['/course/list']);

    return EMPTY;
  };

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<Course> | Observable<never> {
    const id = +route.paramMap.get('id')!;

    return this.courseService.getCourse(id).pipe(
      catchError(this.handleError),
      mergeMap(course => {
        if (course) {
          return of(course);
        }

        this.handleError();
      })
    );
  }
}
